import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button, { ButtonGroup } from '@atlaskit/button';
import IssuesIcon from '@atlaskit/icon/glyph/issues';

// @source
import { RouteLink } from '../../../components';
import * as Styled from '../styled';

const Finish = props => (
  <div style={{ display: props.current ? 'block' : 'none' }}>
    <Styled.Finish>
      <IssuesIcon size="large" />
      <h3>Congratulations!</h3>
      <p>
        For creating a new report use the following buttons or view the your reports.
      </p>
      <br />
      <br />
      <ButtonGroup>
        <Button
          appearance="primary"
          component={RouteLink}
          href="/handover/u3pzcheb2n"
        >
          Create report
        </Button>
        <Button
          component={RouteLink}
          href="/reports"
        >
          View reports
        </Button>
      </ButtonGroup>
    </Styled.Finish>
  </div>
);

Finish.propTypes = {
  current: PropTypes.bool.isRequired,
};

export default Finish;
